var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedUpgrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    fill: "#6C5AFC",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 54H35a3 3 0 00-3 3v3a3 3 0 003 3h15a3 3 0 003-3v-3a3 3 0 00-3-3zm0 6H35v-3h15v3zM61.56 39.44l-18-18a1.5 1.5 0 00-2.12 0l-18 18A1.5 1.5 0 0024.5 42H32v6a3.003 3.003 0 003 3h15a3.005 3.005 0 003-3v-6h7.5a1.5 1.5 0 001.06-2.56zM50 39v9H35v-9h-6.88L42.5 24.62 56.879 39h-6.88z",
    fill: "#6C5AFC"
  })));
}
export default SvgLedUpgrade;